<template>
  <div class="processing-dots" :uk-tooltip="tooltipText">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  name: "ProcessingDots",
  props: {
    tooltipText: {
      type: String,
      required: false,
      default: ""
    }
  }
}
</script>

<style scoped>
.processing-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
}

.processing-dots span {
  width: 8px;
  height: 8px;
  background-color: #6c757d;
  border-radius: 50%;
  display: inline-block;
  animation: dot-pulse 1.4s infinite ease-in-out both;
}

.processing-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.processing-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

.processing-dots span:nth-child(3) {
  animation-delay: 0s;
}

@keyframes dot-pulse {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
